﻿import datatable from './components/dataTable.vue';

const tableApp = {
    components: { datatable },
};

export default tableApp;
